import { createSlice } from "@reduxjs/toolkit";
import { navigationInitState, navigationSliceName } from ".";
import { navigationInitAction } from "./navigationInitAction";

const navigationSlice = createSlice({
  name: `${navigationSliceName}`,
  initialState: navigationInitState,
  reducers: {
    openShortcut: (state) => {
      state.shortcutOpen = true;
    },
    closeShortcut: (state) => {
      state.shortcutOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(navigationInitAction.fulfilled, (state, action) => {
      state.shortcutOpen = false;
      state.items = action.payload;
    });
  },
});

const navigationReducer = navigationSlice.reducer;
export default navigationReducer;
export const { openShortcut, closeShortcut } = navigationSlice.actions;
